import {useTranslation} from 'react-i18next';
import {SubscriptionPlan} from '../../../redux/subscription/subscription.type';

export const useSubscriptionFilters = (subscriptionPlans: SubscriptionPlan[]) => {
    const {t} = useTranslation('subscriptions');
    
    const subscriptionTypeSet = new Set();
    subscriptionPlans.forEach((plan: SubscriptionPlan) => {
        if(plan.planType) {
            subscriptionTypeSet.add(plan.planType);
        }
    });
    
    const uniqueSubscriptionTypeArray = Array.from(subscriptionTypeSet).map((type: string) => ({
        key: type,
        text: t(`planType.${type}`),
        type: 'radioBtn',
    }));
    
    const titleTableArray = [
        {text: t('subscriptionType'), field: 'subscriptionType', action: 'filter', list: {
            array: [{text: t('all'), key: 'all', type: 'radioBtn'}].concat([...uniqueSubscriptionTypeArray]),
            title: t('filterBySubscriptionType'), filterField: 'planType'}},
        {text: t('alphabetical'), field: 'title', action: 'sort'},
        // {text: t('saleValidity'), field: 'saleValidity', action: 'filter'},
        // {text: t('priceRange'), field: 'priceRange', action: 'filter'},
        {text: t('sales'), field: 'amountAvailable', action: 'sort'},
        {text: t('status'), field: 'active', action: 'filter', list: {
            array: [
                {text: t('all'), key: 'all', type: 'radioBtn'},
                {text: t('active'), key: 'active', type: 'radioBtn'},
                {text: t('inactive'), key: 'inactive', type: 'radioBtn'}
            ],
            title: t('filterByActiveStatus'), filterField: 'activeStatus'}},
    ];
    
    return titleTableArray;
};
